import { render, staticRenderFns } from "./suitch-raw-details-widget.vue?vue&type=template&id=137e2a03&"
import script from "./suitch-raw-details-widget.vue?vue&type=script&lang=js&"
export * from "./suitch-raw-details-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports